<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 32.667 32.667">
      <g id="Group_27557" data-name="Group 27557" transform="translate(0.333 0.333)">
        <g id="Group_27558" data-name="Group 27558">
          <path id="Path_71027" data-name="Path 71027"
            d="M17.833,10.833A4.67,4.67,0,0,1,12.3,15.421a5.071,5.071,0,0,1-3.8-4.816V9.195a5.071,5.071,0,0,1,3.8-4.816,4.67,4.67,0,0,1,5.536,4.588Z"
            transform="translate(2.833 1.433)" fill="none" :stroke="themeColor" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2" />
          <circle id="Ellipse_1086" data-name="Ellipse 1086" cx="15.333" cy="15.333" r="15.333"
            transform="translate(0.667 0.667)" fill="none" :stroke="themeColor" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2" />
          <path id="Path_71028" data-name="Path 71028"
            d="M4.16,22.047A11.363,11.363,0,0,1,14.613,15.5a11.363,11.363,0,0,1,10.453,6.547"
            transform="translate(1.387 5.167)" fill="none" :stroke="themeColor" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { useChatSettingsStore } from '../../../store/ChatSettingsStore/ChatSettingsStore';
import { mapWritableState } from 'pinia';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '26px',
    },
    width: {
      type: String,
      required: false,
      default: '26px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
